import { InvoiceItem } from "../../GeneratedClients/FreeBillApi"

const validateInvoiceItems = (invoiceItems: InvoiceItem[]) => {
  var isValid = true
  invoiceItems.forEach(invoiceItem => {
    if(!invoiceItem.price || !invoiceItem.quantity) return isValid = false
    const netAmount = invoiceItem.price * invoiceItem.quantity
    if(netAmount === 0) isValid = false
  })
  return isValid
}

export default validateInvoiceItems